/** 通用 */
export default {
    add: "新增", // 新增
    operate: "操作", // 操作
    update: "修改", // 修改
    delete: "删除", // 删除
    search: "搜索", // 搜索
    refresh: "刷新", // 重置 刷新
    export: "导出", // 导出
    systemStatus: "系统状态", // 系统状态
    systemStatusPlaceholder: "请选择系统状态", // 请选择系统状态
    remark: "备注", // 备注
    numericalOrder: "序号", // 顺序号
    welcome: "欢迎您", // 欢迎您
    goBack: "返回", // 返回
}